import { notification } from 'antd';
import { API_BASE_URL } from '../config';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import { useState } from 'react';
import { removePicksResponse } from '../api/models';
import { PageBody, PageHead } from '../layout';
import { Callout, UploadDropzone } from '../components/ui';

const RemovePicks = () => {
  const [skippedDomains, setSkippedDomains] = useState<string[]>();

  function onChange(info: UploadChangeParam<UploadFile<any>>) {
    if (info.file.status === 'done') {
      try {
        setSkippedDomains(removePicksResponse.parse(info.file.response).unknownDomains);
        notification.success({ message: 'Picks successfully removed.' });
      } catch (e) {
        notification.error({ message: 'Failed to process' });
      }
    } else if (info.file.status === 'error') {
      notification.error({ message: 'Failed to remove picks.' });
    }
  }

  function onDrop() {
    setSkippedDomains(undefined);
  }

  return (
    <>
      <PageHead
        title="Remove Picks"
        subtitle="Tag domains as NeverPick and reset their pick status."
      />
      <PageBody>
        <div className="flex flex-col gap-4">
          <Callout tone="warn" title="Heads up">
            Domains uploaded here will be tagged with <strong>NeverPick</strong> and will never be
            automatically picked again by the system. Their pick status will be reset to pending.
          </Callout>
          <p className="text-text-2 text-[12.5px]">
            Drop a file with domains below to remove them from picks and prevent future
            autopicking.
          </p>
          <UploadDropzone
            action={API_BASE_URL + '/v1/domainLeads/remove-picks'}
            onChange={onChange}
            onDrop={onDrop}
          />
          {skippedDomains && (
            <div>
              <div className="text-[10px] uppercase tracking-wider text-text-3 font-semibold mb-1.5">
                Domains Skipped ({skippedDomains.length})
              </div>
              {skippedDomains.length === 0 ? (
                <p className="text-text-3 text-[12.5px]">None</p>
              ) : (
                <ul className="font-mono text-[11.5px] text-text-2 bg-bg-elevated border border-border rounded-md p-3 max-h-[300px] overflow-auto">
                  {skippedDomains.map((domain) => (
                    <li key={domain}>{domain}</li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </PageBody>
    </>
  );
};

export default RemovePicks;
